import Seo from "../components/Seo";
import { TrustSignals, WhyUs, CTA } from "../components/sections";
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { MELB_IMG } from "../data/site";

export default function About() {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/content/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  return (
    <>
      <Seo title="About Car To Cash | Trusted Car Buyers in Victoria" description="Car To Cash has been buying cars for cash across Melbourne and regional Victoria for over 20 years. Fair valuations, on-the-spot payment and free removal." canonical="https://cartocash.com.au/about" />
      <section className="relative noise-dark text-white">
        <div className="absolute inset-0 opacity-20"><img src={MELB_IMG} alt="Melbourne" className="h-full w-full object-cover" /></div>
        <div className="relative mx-auto max-w-4xl px-4 sm:px-6 py-16">
          <h1 className="font-display text-4xl sm:text-5xl font-black">About Car To Cash</h1>
          <p className="mt-4 text-lg text-white/80 max-w-2xl">We're a local, family-run car buying business that's been turning cars into cash across Melbourne and regional Victoria for over two decades.</p>
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-4 sm:px-6 py-16 space-y-5 text-lg leading-relaxed text-brand-navy">
        <p>Selling a car privately is a hassle — endless calls, no-shows and lowball offers. We started Car To Cash to make it simple: a fair price based on real market conditions, a quick inspection, and cash in your hand the same day.</p>
        <p>Our team of experienced buyers has purchased thousands of vehicles of every make, model, year and condition. Whether it's a tidy late-model car, an unwanted second vehicle, or a scrap car that hasn't started in years, we treat every seller with the same honesty and no-pressure approach.</p>
        <p>We handle all the paperwork, arrange finance payouts where needed, and include free removal with every purchase. Our offers are always honoured for 7 days, because we think you should have time to decide without being rushed.</p>
      </section>
      <TrustSignals settings={settings} />
      <WhyUs />
      <CTA />
    </>
  );
}
